import { Box, Icon, Text } from '@quintoandar-tokko/jopijs';
import styles from './styles.module.scss';

const QUALIFICATION = {
  POSITIVE: 1,
  NEGATIVE: 2,
  NEUTRAL: 3,
  UNRATED: 0,
};

const QUALIFICATION_ICON = {
  [QUALIFICATION.UNRATED]: 'icon-mostrarmenos',
  [QUALIFICATION.POSITIVE]: 'icon-positivo',
  [QUALIFICATION.NEGATIVE]: 'icon-negativo',
  [QUALIFICATION.NEUTRAL]: 'icon-neutro',
};

const QUALIFICATION_STR = {
  [QUALIFICATION.UNRATED]: 'without_calification',
  [QUALIFICATION.POSITIVE]: 'positive',
  [QUALIFICATION.NEGATIVE]: 'negative',
  [QUALIFICATION.NEUTRAL]: 'neutral',
};

export default function ClosureReasonCell({ qualification, reason, ...rest }) {
  const qualificationStr =
    QUALIFICATION_STR[qualification] ??
    QUALIFICATION_STR[QUALIFICATION.UNRATED];

  const qualificationIcon =
    QUALIFICATION_ICON[qualification] ??
    QUALIFICATION_ICON[QUALIFICATION.UNRATED];

  return (
    <Box
      className={styles.closureReason}
      data-qualification={qualificationStr}
      {...rest}
    >
      <Icon className={styles.closureReasonIcon} icon={qualificationIcon} />

      {reason && <Text className={styles.closureReasonText}>{reason}</Text>}
    </Box>
  );
}
